import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { AgreementId, } from "../../Types";
import ValidationError from "../../ZodError";
export const customDocumentTypeOptions = [
    "Custom Client Agreements (IAA, CRS, ADV)",
    "Custom IRA Rollover Notice",
];
const Response = z.object({
    signatureId: z.string(),
    signatureUrl: z.string().url(),
    agreementIds: AgreementId.array(),
});
const url = (planId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/account/v2/plans/${planId}/documents/custom`
    : `https://middleware.uat.farther.com/account/v2/plans/${planId}/documents/custom`;
const createBody = (clientIds, documentType, document) => {
    const formData = new FormData();
    const documentData = JSON.stringify({ clientIds, documentType });
    formData.append("documentData", documentData);
    formData.append("document", document);
    return formData;
};
export default async function uploadCustomPlanDocumentV2(planId, clientIds, documentType, document, config) {
    const { data } = await axios.post(url(planId), createBody(clientIds, documentType, document), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
            "Content-Type": "multipart/form-data",
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `${uploadCustomPlanDocumentV2} Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=uploadCustomPlanDocumentV2.js.map